import { createSelector } from 'reselect';
import { mapWithDefault } from '../../../utils/dataMapper';

const selectPetMedicalStep = (state) => state.get('petMedicalStep');

const makeSelectPetMedicalStep = () => createSelector(
  selectPetMedicalStep,
  (stepMedicalExpenseStepState) => ({
    doYouHaveOtherTypeOfPetInsurance: mapWithDefault(
      stepMedicalExpenseStepState,
      () => stepMedicalExpenseStepState.getIn(['form', 'doYouHaveOtherTypeOfPetInsurance']),
      ''
    ),
    companyName: mapWithDefault(
      stepMedicalExpenseStepState,
      () => stepMedicalExpenseStepState.getIn(['form', 'companyName']),
      ''
    ),
    address: mapWithDefault(
      stepMedicalExpenseStepState,
      () => stepMedicalExpenseStepState.getIn(['form', 'address']),
      ''
    ),
    cityOrTown: mapWithDefault(
      stepMedicalExpenseStepState,
      () => stepMedicalExpenseStepState.getIn(['form', 'cityOrTown']),
      ''
    ),
    country: mapWithDefault(
      stepMedicalExpenseStepState,
      () => stepMedicalExpenseStepState.getIn(['form', 'country']),
      ''
    ),
    postalCode: mapWithDefault(
      stepMedicalExpenseStepState,
      () => stepMedicalExpenseStepState.getIn(['form', 'postalCode']),
      ''
    ),
    policyId: mapWithDefault(
      stepMedicalExpenseStepState,
      () => stepMedicalExpenseStepState.getIn(['form', 'policyId']),
      ''
    ),
    forEUCitizens: mapWithDefault(
      stepMedicalExpenseStepState,
      () => stepMedicalExpenseStepState.getIn(['form', 'forEUCitizens']),
      ''
    ),
    ifYesWasTheEHIC: mapWithDefault(
      stepMedicalExpenseStepState,
      () => stepMedicalExpenseStepState.getIn(['form', 'ifYesWasTheEHIC']),
      ''
    ),
    ifNoPleaseExplain: mapWithDefault(
      stepMedicalExpenseStepState,
      () => stepMedicalExpenseStepState.getIn(['form', 'ifNoPleaseExplain']),
      ''
    ),
    changeTo: mapWithDefault(
      stepMedicalExpenseStepState,
      () => stepMedicalExpenseStepState.getIn(['form', 'changeTo']),
      ''
    ),
    ifYesNameOfPhysicianCurrentlyTreatingThis: mapWithDefault(
      stepMedicalExpenseStepState,
      () => stepMedicalExpenseStepState.getIn(['form', 'ifYesNameOfPhysicianCurrentlyTreatingThis']),
      ''
    ),
    // New Screen
    dateTravelArrangementsWereMade: mapWithDefault(
      stepMedicalExpenseStepState,
      () => stepMedicalExpenseStepState.getIn(['form', 'dateTravelArrangementsWereMade']),
      ''
    ),
    dateOfInitialPaymentDeposit: mapWithDefault(
      stepMedicalExpenseStepState,
      () => stepMedicalExpenseStepState.getIn(['form', 'dateOfInitialPaymentDeposit']),
      ''
    ),
    typeOfPolicy: mapWithDefault(
      stepMedicalExpenseStepState,
      () => stepMedicalExpenseStepState.getIn(['form', 'typeOfPolicy']),
      ''
    ),
    contact: mapWithDefault(
      stepMedicalExpenseStepState,
      () => stepMedicalExpenseStepState.getIn(['form', 'contact']),
      ''
    ),
    phoneNumber: mapWithDefault(
      stepMedicalExpenseStepState,
      () => stepMedicalExpenseStepState.getIn(['form', 'phoneNumber']),
      ''
    ),
    haveYouFiledAClaimWithTheirOfficeAtThisTime: mapWithDefault(
      stepMedicalExpenseStepState,
      () => stepMedicalExpenseStepState.getIn(['form', 'haveYouFiledAClaimWithTheirOfficeAtThisTime']),
      ''
    ),
    isTheClaimTheResultOfASicknessOrInjury: mapWithDefault(
      stepMedicalExpenseStepState,
      () => stepMedicalExpenseStepState.getIn(['form', 'isTheClaimTheResultOfASicknessOrInjury']),
      ''
    ),
    natureOfSickness: mapWithDefault(
      stepMedicalExpenseStepState,
      () => stepMedicalExpenseStepState.getIn(['form', 'natureOfSickness']),
      ''
    ),
    accidentOfInjury: mapWithDefault(
      stepMedicalExpenseStepState,
      () => stepMedicalExpenseStepState.getIn(['form', 'accidentOfInjury']),
      ''
    ),
    dateNature: mapWithDefault(
      stepMedicalExpenseStepState,
      () => stepMedicalExpenseStepState.getIn(['form', 'dateNature']),
      ''
    ),
    placeNature: mapWithDefault(
      stepMedicalExpenseStepState,
      () => stepMedicalExpenseStepState.getIn(['form', 'placeNature']),
      ''
    ),
    fromDateNature: mapWithDefault(
      stepMedicalExpenseStepState,
      () => stepMedicalExpenseStepState.getIn(['form', 'fromDateNature']),
      ''
    ),
    toDateNature: mapWithDefault(
      stepMedicalExpenseStepState,
      () => stepMedicalExpenseStepState.getIn(['form', 'toDateNature']),
      ''
    ),
    endDateNature: mapWithDefault(
      stepMedicalExpenseStepState,
      () => stepMedicalExpenseStepState.getIn(['form', 'endDateNature']),
      ''
    ),
    wasThereAnAccidentReportForThisIncident: mapWithDefault(
      stepMedicalExpenseStepState,
      () => stepMedicalExpenseStepState.getIn(['form', 'wasThereAnAccidentReportForThisIncident']),
      ''
    ),
    pleaseNoteTheirResponse: mapWithDefault(
      stepMedicalExpenseStepState,
      () => stepMedicalExpenseStepState.getIn(['form', 'pleaseNoteTheirResponse']),
      ''
    ),
    whyNot: mapWithDefault(
      stepMedicalExpenseStepState,
      () => stepMedicalExpenseStepState.getIn(['form', 'whyNot']),
      ''
    ),
    petName: mapWithDefault(
      stepMedicalExpenseStepState,
      () => stepMedicalExpenseStepState.getIn(['form', 'petName']),
      ''
    ),
    canineOrFeline: mapWithDefault(
      stepMedicalExpenseStepState,
      () => stepMedicalExpenseStepState.getIn(['form', 'canineOrFeline']),
      ''
    ),
    petWeight: mapWithDefault(
      stepMedicalExpenseStepState,
      () => stepMedicalExpenseStepState.getIn(['form', 'petWeight']),
      ''
    ),
    unit: mapWithDefault(
      stepMedicalExpenseStepState,
      () => stepMedicalExpenseStepState.getIn(['form', 'unit']),
      ''
    ),
    dateSicknessOrInjuryBegan: mapWithDefault(
      stepMedicalExpenseStepState,
      () => stepMedicalExpenseStepState.getIn(['form', 'dateSicknessOrInjuryBegan']),
      ''
    ),
    dateFirstTreated: mapWithDefault(
      stepMedicalExpenseStepState,
      () => stepMedicalExpenseStepState.getIn(['form', 'dateFirstTreated']),
      ''
    ),
    natureOfInjury: mapWithDefault(
      stepMedicalExpenseStepState,
      () => stepMedicalExpenseStepState.getIn(['form', 'natureOfInjury']),
      ''
    ),
    expenseDescriptionOfItems: mapWithDefault(stepMedicalExpenseStepState, () => stepMedicalExpenseStepState.getIn(['form', 'expenseDescriptionOfItems']) && stepMedicalExpenseStepState.getIn(['form', 'expenseDescriptionOfItems']).toJS(), ''),
  })
);

const makeSelectPetMedicalStepErrors = () =>
  createSelector(selectPetMedicalStep, (state) => state.get('errors'));

export {
  makeSelectPetMedicalStep,
  makeSelectPetMedicalStepErrors,
};



// WEBPACK FOOTER //
// ./app/containers/FastCover/Trawick.NationWide.PetMedicalStep/selectors.js